<template>
  <div class="layout-view">
    <Title title="按学历分析" className="ny-title-small"></Title>
    <div class="layout-view withoutTitle pb0">
      <EchartsLayout :option="option"></EchartsLayout>
    </div>
  </div>
</template>

<script>
import { getCacheOrRequest } from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import Title from "@/components/common/Title.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  components: {
    Title,
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "post",
        url: `/home/getStaffAnalysisList`,
        param: {
          dimension: "education",
        },
        success: (response) => {
          let arr = [];
          response.data &&
            response.data.data &&
            response.data.data.map &&
            response.data.data.map((item) => {
              arr.push([item.level, item.number]);
            });

          // 更新配置
          this.option = {
            grid: {
              left: 100,
              right: 0,
            },
            series: [
              {
                type: "bar",
                name: "数量",
                showItemStyle: true,
                label: { rotate: 90 },
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 1,
                    x2: 0,
                    y2: 0,
                    colorStops: [
                      { offset: 1, color: "rgba(0, 97, 206, 1)" },
                      { offset: 0, color: "rgba(45, 198, 248, 1)" },
                    ],
                    globalCoord: false,
                  },
                  borderRadius: 50,
                },
              },
            ],
            tooltip: { textStyle: { fontSize: 54 } },
            xAxis: {
              axisLine: { lineStyle: { color: "white" } },
              type: "category",
              lineHeight: 50,
              axisLabel: {
                interval: 0,
                textStyle: {
                  fontSize: 30,
                  fontWeight: 700,
                },
              },
            },
            yAxis: {
              axisLine: { lineStyle: { color: "white" } },
              boundaryGap: [0, 0.01],
              type: "value",
              axisLabel: {
                textStyle: {
                  fontSize: 34,
                  fontWeight: 700,
                },
              },
            },
            dataset: {
              source: [["level", "number"], ...arr],
            },
          };
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
